import _classCallCheck from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */

/**
 *  Advanced activation layers.
 */
import { cast, clipByValue, elu, greater, leakyRelu, mul, prelu, relu, serialization } from '@tensorflow/tfjs-core';
import { Softmax as softmaxActivation } from '../activations';
import { getConstraint, serializeConstraint } from '../constraints';
import { InputSpec, Layer } from '../engine/topology';
import { NotImplementedError, ValueError } from '../errors';
import { getInitializer, serializeInitializer } from '../initializers';
import { getRegularizer, serializeRegularizer } from '../regularizers';
import { getExactlyOneShape, getExactlyOneTensor } from '../utils/types_utils';
export var ReLU = /*#__PURE__*/function (_Layer) {
  _inherits(ReLU, _Layer);

  function ReLU(args) {
    var _this;

    _classCallCheck(this, ReLU);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReLU).call(this, args == null ? {} : args));
    _this.supportsMasking = true;

    if (args != null) {
      _this.maxValue = args.maxValue;
    }

    return _this;
  }

  _createClass(ReLU, [{
    key: "call",
    value: function call(inputs, kwargs) {
      inputs = getExactlyOneTensor(inputs);
      var output = relu(inputs);

      if (this.maxValue != null) {
        output = clipByValue(output, 0, this.maxValue);
      }

      return output;
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return inputShape;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        maxValue: this.maxValue
      };

      var baseConfig = _get(_getPrototypeOf(ReLU.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return ReLU;
}(Layer);
/** @nocollapse */

ReLU.className = 'ReLU';
serialization.registerClass(ReLU);
export var LeakyReLU = /*#__PURE__*/function (_Layer2) {
  _inherits(LeakyReLU, _Layer2);

  function LeakyReLU(args) {
    var _this2;

    _classCallCheck(this, LeakyReLU);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LeakyReLU).call(this, args == null ? {} : args));
    _this2.DEFAULT_ALPHA = 0.3;

    if (args == null) {
      args = {};
    }

    _this2.alpha = args.alpha == null ? _this2.DEFAULT_ALPHA : args.alpha;
    return _this2;
  }

  _createClass(LeakyReLU, [{
    key: "call",
    value: function call(inputs, kwargs) {
      var x = getExactlyOneTensor(inputs);
      return leakyRelu(x, this.alpha);
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return inputShape;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        alpha: this.alpha
      };

      var baseConfig = _get(_getPrototypeOf(LeakyReLU.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return LeakyReLU;
}(Layer);
/** @nocollapse */

LeakyReLU.className = 'LeakyReLU';
serialization.registerClass(LeakyReLU);
export var PReLU = /*#__PURE__*/function (_Layer3) {
  _inherits(PReLU, _Layer3);

  function PReLU(args) {
    var _this3;

    _classCallCheck(this, PReLU);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PReLU).call(this, args == null ? {} : args));
    _this3.DEFAULT_ALPHA_INITIALIZER = 'zeros';

    if (args == null) {
      args = {};
    }

    _this3.supportsMasking = true;
    _this3.alphaInitializer = getInitializer(args.alphaInitializer || _this3.DEFAULT_ALPHA_INITIALIZER);
    _this3.alphaRegularizer = getRegularizer(args.alphaRegularizer);
    _this3.alphaConstraint = getConstraint(args.alphaConstraint);

    if (args.sharedAxes == null) {
      _this3.sharedAxes = null;
    } else if (Array.isArray(args.sharedAxes)) {
      _this3.sharedAxes = args.sharedAxes;
    } else if (typeof args.sharedAxes === 'number') {
      _this3.sharedAxes = [args.sharedAxes];
    } else {
      throw new ValueError("Expected sharedAxes to be a number or an array of numbers, " + "but got ".concat(args.sharedAxes));
    }

    return _this3;
  }

  _createClass(PReLU, [{
    key: "build",
    value: function build(inputShape) {
      inputShape = getExactlyOneShape(inputShape);
      var paramShape = inputShape.slice(1);

      if (this.sharedAxes != null) {
        var _iterator = _createForOfIteratorHelper(this.sharedAxes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            paramShape[i - 1] = 1;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      this.alpha = this.addWeight('alpha', paramShape, 'float32', this.alphaInitializer, this.alphaRegularizer, true, this.alphaConstraint); // Set input spec.

      var axes = {};

      if (this.sharedAxes != null) {
        for (var _i = 1; _i < inputShape.length; ++_i) {
          axes[_i] = inputShape[_i];
        }
      }

      this.inputSpec = [new InputSpec({
        ndim: inputShape.length,
        axes: axes
      })];
      this.built = true;
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      inputs = getExactlyOneTensor(inputs);
      return prelu(inputs, this.alpha.read());
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        alphaInitializer: serializeInitializer(this.alphaInitializer),
        alphaRegularizer: serializeRegularizer(this.alphaRegularizer),
        alphaConstraint: serializeConstraint(this.alphaConstraint),
        sharedAxes: this.sharedAxes
      };

      var baseConfig = _get(_getPrototypeOf(PReLU.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return PReLU;
}(Layer);
/** @nocollapse */

PReLU.className = 'PReLU';
serialization.registerClass(PReLU);
export var ELU = /*#__PURE__*/function (_Layer4) {
  _inherits(ELU, _Layer4);

  function ELU(args) {
    var _this4;

    _classCallCheck(this, ELU);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ELU).call(this, args == null ? {} : args));
    _this4.DEFAULT_ALPHA = 1.0;

    if (args == null) {
      args = {};
    }

    if (args.alpha != null && args.alpha !== _this4.DEFAULT_ALPHA) {
      throw new NotImplementedError("Non-default alpha value (".concat(args.alpha, ") is not supported by the ") + "ELU layer yet.");
    }

    _this4.alpha = args.alpha == null ? _this4.DEFAULT_ALPHA : args.alpha;
    return _this4;
  }

  _createClass(ELU, [{
    key: "call",
    value: function call(inputs, kwargs) {
      var x = getExactlyOneTensor(inputs);
      return elu(x);
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return inputShape;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        alpha: this.alpha
      };

      var baseConfig = _get(_getPrototypeOf(ELU.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return ELU;
}(Layer);
/** @nocollapse */

ELU.className = 'ELU';
serialization.registerClass(ELU);
export var ThresholdedReLU = /*#__PURE__*/function (_Layer5) {
  _inherits(ThresholdedReLU, _Layer5);

  function ThresholdedReLU(args) {
    var _this5;

    _classCallCheck(this, ThresholdedReLU);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ThresholdedReLU).call(this, args == null ? {} : args));
    _this5.DEFAULT_THETA = 1.0;

    if (args == null) {
      args = {};
    }

    _this5.theta = args.theta == null ? _this5.DEFAULT_THETA : args.theta;
    return _this5;
  }

  _createClass(ThresholdedReLU, [{
    key: "call",
    value: function call(inputs, kwargs) {
      var x = getExactlyOneTensor(inputs);
      return mul(x, cast(greater(x, this.theta), 'float32'));
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return inputShape;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        theta: this.theta
      };

      var baseConfig = _get(_getPrototypeOf(ThresholdedReLU.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return ThresholdedReLU;
}(Layer);
/** @nocollapse */

ThresholdedReLU.className = 'ThresholdedReLU';
serialization.registerClass(ThresholdedReLU);
export var Softmax = /*#__PURE__*/function (_Layer6) {
  _inherits(Softmax, _Layer6);

  function Softmax(args) {
    var _this6;

    _classCallCheck(this, Softmax);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Softmax).call(this, args == null ? {} : args));
    _this6.DEFAULT_AXIS = 1.0;

    if (args == null) {
      args = {};
    }

    _this6.softmax = new softmaxActivation().apply;
    _this6.axis = args.axis == null ? _this6.DEFAULT_AXIS : args.axis;
    return _this6;
  }

  _createClass(Softmax, [{
    key: "call",
    value: function call(inputs, kwargs) {
      var x = getExactlyOneTensor(inputs);
      return this.softmax(x, this.axis);
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return inputShape;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        axis: this.axis
      };

      var baseConfig = _get(_getPrototypeOf(Softmax.prototype), "getConfig", this).call(this);

      Object.assign(config, baseConfig);
      return config;
    }
  }]);

  return Softmax;
}(Layer);
/** @nocollapse */

Softmax.className = 'Softmax';
serialization.registerClass(Softmax);